export default {
  getParam: function(title) {
    var reg = new RegExp("(^|&|/?)" + name + "=([^&]*)(&|$)");
    var r = window.location.href.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  },
  
};



// WEBPACK FOOTER //
// ./src/common/common.js